module.exports = __webpack_public_path__ + "static/frans-6da81e99804d2729536885d6708c759a.gif";